export const passwordGenerator = (length: number = 8): string => {
    let symbolGroups = ["abcdefghijklmnopqrstuvwxyz", "ABCDEFGHIJKLMNOPQRSTUVWXYZ", "0123456789", "#$@-"];
    let retVal = "";

    for (let i = 0; i < length; i++) {
        let symbols = symbolGroups[Math.floor(Math.random() * symbolGroups.length)];
        retVal += symbols.charAt(Math.floor(Math.random() * symbols.length));
    }

    if (!/[0-9]/.test(retVal)){
        return passwordGenerator(length);
    }
    else if (!/[A-Z,А-Я]/.test(retVal)){
        return passwordGenerator(length);
    }
    else if (!/[a-z,а-я]/.test(retVal)) {
        return passwordGenerator(length);
    }

    return retVal;
};
